import axios from './axios';

import { STAFF_PER_PAGE } from '../constants/Values';

export const searchStaff = (filter, selectedStaffIds) =>
  axios.post('/staff/search', {
    excludedIds: selectedStaffIds,
    filter,
    pagination: {
      pageNumber: 1,
      size: STAFF_PER_PAGE,
      sort: [
        {
          direction: 'ASC',
          property: 'fullName',
        },
      ],
    },
  });
